import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BRAND_NAME, DEFAULT_OG_IMAGE, absoluteUrl } from '../seo';

function FAQ() {
  const pageUrl = absoluteUrl('/faq');
  const pageTitle = 'Frequently Asked Questions';
  const pageDescription =
    'Find answers about Apex Breath courses, subscriptions, supported devices, and activity-specific breathwork sessions.';

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Is Apex Breath free to download?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes. You can download the app for free and start with a 3-day trial.'
        }
      },
      {
        '@type': 'Question',
        name: 'What does Apex Breath help with?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'It helps with calm, focus, recovery, and activity-specific breath control.'
        }
      },
      {
        '@type': 'Question',
        name: 'How long are sessions?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Most routines are short and easy to complete in a quick break.'
        }
      },
      {
        '@type': 'Question',
        name: 'What devices are supported?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Currently Apex Breath is available on iOS.'
        }
      }
    ]
  };

  return (
    <section className="basic-page">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:title" content={`${pageTitle} | ${BRAND_NAME}`} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={DEFAULT_OG_IMAGE} />
        <meta name="twitter:title" content={`${pageTitle} | ${BRAND_NAME}`} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <h1>Frequently Asked Questions</h1>

      <div className="faq-list">
        <article>
          <h2>Is Apex Breath free to download?</h2>
          <p>Yes. You can download the app for free and start with a 3-day trial.</p>
        </article>
        <article>
          <h2>What does Apex Breath help with?</h2>
          <p>It helps with calm, focus, recovery, and activity-specific breath control.</p>
        </article>
        <article>
          <h2>How long are sessions?</h2>
          <p>Most routines are short and easy to complete in a quick break.</p>
        </article>
        <article>
          <h2>What devices are supported?</h2>
          <p>Currently Apex Breath is available on iOS.</p>
        </article>
      </div>
    </section>
  );
}

export default FAQ;
